import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Input, Select, Col, Row, Upload, message, InputNumber, Checkbox, Button, Divider } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import {
	createImageFile,
	setCertificate,
	updateCertificate
} from "../../../modules/actions/managerPanelActions";
import { getSingleItem, getSingleReport, getSingleItemConsultation } from "../../../modules/actions/dataEntryActions";
import { dateFormat } from "../../../common/common";
import upload from "./../../../Images/upload.png";
import DiamondCertificate from "../FieldValues";
import { getColorFormDataAdd, getCutFormDataAdd, getCuttingStyleFormDataAdd, getGridlesFormDataAdd, getObjectsFormDataAdd, getOrigionGemFormDataAdd, getRemarksFormDatAdda, getShapesFormDatAdda, getSpeciesFormDataAdd, getVarietysFormDatAdda } from "../../../modules/actions/FormValues";

const { TextArea } = Input;
const { Option } = Select;

function getBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

function SmallDiamondForm(props) {
	const [obj, setobj] = useState({
		branchCode: props.permission.branchCode,
		relatedEntryNo: "",
		itemId: "",
		Id_of_temp_data: "",
		serial_number: "",
		certificate_number: "",
		color_gem: "",
		weight: "",
		length_gem: "",
		width_gem: "",
		depth_gem: "",
		description: "",
		comments_gem: "",
		species_gem: "",
		variety_gem: "",
		picture_id: "",
		cart_id: "",
		path: "",
		ext: "",
		Fpath: "",
		columnname: "",
		path2: "",
		ext3: "",
		bpath: "",
		customername: "",
		treatment: "",
		Customer_Number: "",
		eptyp_temp: "",
		Number_Of_Diamonds: "",
		Total_Dia_Weight: "",
		Shap_And_Cut: "",
		DiamondCut: "",
		Diamond_Color: "",
		number: "",
		filename: "",
		date: dateFormat(new Date()),
		shape: "",
		cut: "",
		measurement_mm: "",
		measurements: "",
		measurements2: "",
		measurements3: "",
		measurement_unit: "",
		depth: "",
		table: "",
		gridle: "",
		gridle2: "",
		gridle3: "",
		crown_angle: "",
		pavilion_depth: "",
		culet: "",
		polish: "",
		symmetry: "",
		flourescence: "",
		flourescenceColor: "",
		carat_weight: "",
		weight_unit: "",
		color: "",
		clarity: "",
		cut_grade: "",
		entry_date: dateFormat(new Date()),
		comment: "",
		key_to_symbol: "",
		object: "",
		transparency: "",
		species: "",
		variety: "",
		report_id: 5,
		report_page: "",
		remarks: "",
		finish: "",
		diamond1: "",
		diamond2: "",
		diamond3: "",
		diamond4: "",
		diamond5: "",
		key_symbol1: "",
		key_symbol2: "",
		key_symbol3: "",
		key_symbol4: "",
		key_symbol5: "",
		key_symbol6: "",
		key_symbol7: "",
		key_symbol8: "",
		key_symbol9: "",
		key_symbol10: "",
		key_symbol11: "",
		key_symbol12: "",
		key_symbol13: "",
		key_symbol14: "",
		key_symbol15: "",
		key_symbol16: "",
		key_symbol17: "",
		key_symbol18: "",
		disabled_key_symbol: "",
		origion_gem: "",
		pavilion_angle_d: "",
		color_grade: "",
		clarity_grade: "",
		Enhancements: "",
		RI: "",
		RI1: "",
		Polariscope: "",
		uv_flourescence: "",
		micro_evidence: "",
		cutting_style: "",
		microscope: "",
		FTIR: "",
		UV: "",
		Refractometer: "",
		Lamp: "",
		XRF: "",
		uv_flourescence1: ""
	});

	const [runOn, setRunOn] = useState(false);

	const [isReported, setIsReported] = useState(false);

	const [loading, setLoading] = useState(false);
	const [imageUrl, setImageUrl] = useState("");
	const [image, setImage] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [weightUnit,setWeightUnit] = useState('CT')

	function handleChange(e) {
		setImageUrl(e.target.files[0]);
		getBase64(e.target.files[0]).then((data) => {
			setImage(data);
		});
	}

	useEffect(() => {
		var url = new URL(window.location);
		let entryNo = url.searchParams.get("entryNo");
		let id = url.searchParams.get("id");
		let editId = url.searchParams.get("editId");
		let consultation = url.searchParams.get("consultation");

		if (editId) {
			setIsEdit(true);
			props.getSingleReport(editId, props.permission.branchCode);
		} else {
			let objj = { ...obj };
			objj.relatedEntryNo = entryNo;
			objj.itemId = Number(id);
			objj.entry_date = dateFormat(new Date());
			objj.date = dateFormat(new Date());
			if (consultation === '1') {
				props.getSingleItemConsultation(id, props.permission.branchCode);
			} else {
				props.getSingleItem(id, props.permission.branchCode);
			}
			setobj(objj);
		}
	}, []);

	useEffect(() => {
		if (props.singleItemEntry) {
			var url = new URL(window.location);
			let objj = obj;
			objj.carat_weight = Number(props.singleItemEntry.weight);
			objj.color = props.singleItemEntry.color;
			if (props.singleItemEntry.report && props.singleItemEntry.report.length) {
				setIsReported(true);
			} else {
				setIsReported(false);
			}
			setRunOn(runOn ? false : true);
			setobj(objj);
		}
		if (props.singleReportEntry) {
			console.log(props.singleReportEntry);
			if (props.singleReportEntry.relatedEntryNo) {
				console.log("no old entry no");
				setobj(props.singleReportEntry);
			} else {
				props.singleReportEntry.relatedEntryNo = "oldData";
				setobj(props.singleReportEntry);
			}
		}
	}, [props.singleItemEntry, props.singleReportEntry]);

	useEffect(() => { }, [runOn]);

	function backFun() {
		props.history.goBack();
	}
	const [name, setName] = useState(false);
	const [flourColorOpt, setFlourColorOpt] = useState([
		"None",
		"Green",
		"Blue",
		"Dark Blue",
		"Light Red",
		"Dark Red",
		"Dark Green"
		// "Other",
	]);

	const save = () => {
		var url = new URL(window.location);

		let entryNo = url.searchParams.get("entryNo");
		let data = new FormData();
		for (const property in obj) {
			if (obj[property]) {
				data.append(property, obj[property]);
			} else if (property === "relatedEntryNo" && !obj[property] && entryNo) {
				data.append(property, entryNo);
			}
		}
		let entryId = url.searchParams.get("id");
		data.append("itemId", Number(entryId));
		console.log(entryId);

		data.append("product_pic", imageUrl);
		props.setCertificate(data, props.permission.branchCode, clearState, backFun);
	};

	const update = () => {
		let data = new FormData();
		let imageFile = [];
		console.log(obj, 'objobj')
		for (const property in obj) {
			if (property === "product_pic") {
				if (obj[property]) {

					createImageFile(imageUrl ? imageUrl : obj[property]).then((result) => {
						// imageFile.push(result);

						data.append(property, result);
					});
				}
				else {

					createImageFile(imageUrl ? imageUrl : obj[property]).then((result) => {
						// imageFile.push(result);

						data.append(property, result);
					});
				}
			}
			else if (property.toLowerCase().match("fpath")) {
				data.append(property, '')
				// if(obj[property]){

				// createImageFile(imageUrl ? imageUrl : obj[property]).then((result) => {
				// 	// imageFile.push(result);

				// 	data.append(property, result);
				// });
				// }
				// else{

				// createImageFile(imageUrl ? imageUrl : obj[property]).then((result) => {
				// 	// imageFile.push(result);

				// 	data.append(property, result);
				// });
				// }				// data.set(property, "");
			}
			else if (obj[property]) {
				data.append(property, obj[property]);
			}
		}

		props.updateCertificate(data, props.permission.branchCode, clearState, obj.id, backFun);
	};

	const clearState = () => {
		let objj = obj;
		for (let keys in objj) {
			objj[keys] = "";
		}
		setobj(objj);
		setRunOn(runOn ? false : true);
	};




	const [shapeArr, setShapeArr] = useState([])
	const [shapeName, setShapeName] = useState(false);
	const onShapeChange = (event) => {
		setShapeName(event.target.value);
	};

	const addShapeOpt = () => {
		if (shapeName) {
			if (shapeArr.filter(obj => obj.value.toLowerCase() === shapeName.toLowerCase()).length) {
				message.error('Shape is already exist')
			} else {
				console.log("addItem");
				setShapeArr([...shapeArr, { value: shapeName }]);
				props.getShapesFormDatAdda({ value: shapeName })
				setShapeName(false);
			}
		}
	};


	const [cutArr, setCutArr] = useState([])
	const [cutName, setCutName] = useState(false);
	const onCutChange = (event) => {
		setCutName(event.target.value);
	};

	const addCutOpt = () => {
		if (cutName) {
			if (cutArr.filter(obj => obj.value.toLowerCase() === cutName.toLowerCase()).length) {
				message.error('Cut is already exist')
			} else {
				console.log("addItem");
				setCutArr([...cutArr, { value: cutName }]);
				props.getCutFormDataAdd({ value: cutName })
				setCutName(false);
			}
		}
	};

	const [commentArr, setCommentArr] = useState([])
	const [commentName, setCommentName] = useState(false);
	const onCommentChange = (event) => {
		setCommentName(event.target.value);
		let obj2 = { ...obj };
		obj2.comment = event.target.value;
		setobj(obj2);
	};

	const addCommentOpt = () => {
		if (commentName) {
			console.log("addItem");
			setCommentArr([...commentArr, commentName]);
			setCommentName(false);
		}
	};

	const [colorArr, setColorArr] = useState([])
	const [colorName, setColorName] = useState(false);
	const onColorChange = (event) => {
		setColorName(event.target.value);
	};

	const addColorOpt = () => {
		if (colorName) {
			if (colorArr.filter(obj => obj.name.toLowerCase() === colorName.toLowerCase()).length) {
				message.error('Color is already exist')
			} else {
				console.log("addItem");
				setColorArr([...colorArr, { name: colorName }]);
				props.getColorFormDataAdd({ name: colorName })
				setColorName(false);
			}
		}
	};


	useEffect(() => {
		if (props.fields) {
			setCutArr(props.fields.cuts)
			setShapeArr(props.fields.shapes)
			setColorArr(props.fields.color)
			setCommentArr(props.fields.comment)

			// setSpeciesArr(props.fields.species)
			// setObjectsArr(props.fields.objects)
			// setVarietyArr(props.fields.variety)
			// setOriginArr(props.fields.origion_gem)

		}
		console.log(props.fields, 'props.fields')
	}, [props.fields])


	return (
		<div className="DiamondGradingFrom SmallJewelleryForm">
			{!isReported ? (
				<div className="innerGradingForm">
					<Row className="spaceBetween">
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Date</h6>
									<Input
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.date = e.target.value;
											setobj(obj2);
										}}
										value={dateFormat(obj.date ? obj.date : obj.entry_date)}
										type="date"
									/>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Measurements</h6>
									<div className="wieghtNumber spaceBetween">
										<Input
											onChange={(e) => {
												let obj2 = { ...obj };
												obj2.measurements = e.target.value;
												setobj(obj2);
											}}
											value={obj.measurements}
										/>
										<span>*</span>
										<Input
											onChange={(e) => {
												let obj2 = { ...obj };
												obj2.measurements2 = e.target.value;
												setobj(obj2);
											}}
											value={obj.measurements2}
										/>
										<span>*</span>
										<Input
											onChange={(e) => {
												let obj2 = { ...obj };
												obj2.measurements3 = e.target.value;
												setobj(obj2);
											}}
											value={obj.measurements3}
										/>
									</div>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Shape</h6>
									<Select
										showSearch
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.shape = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue="N/A"
										value={obj.shape}
										dropdownRender={(menu) => (
											<div>
												{menu}
												<Divider style={{ margin: "4px 0" }} />
												<div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
													<Input
														style={{ flex: "auto" }}
														value={shapeName ? shapeName : ""}
														onChange={onShapeChange}
													/>
													{shapeName ? (
														<a
															style={{
																flex: "none",
																padding: "8px",
																display: "block",
																cursor: "pointer"
															}}
															onClick={addShapeOpt}
														>
															<PlusOutlined />
														</a>
													) : null}
												</div>
											</div>
										)}
									>
										{shapeArr.length && shapeArr.map((a, i) => (
											<Option value={a.value}>{a.value}</Option>
										))}
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Cut</h6>
									<Select
										showSearch
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.cut = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue="N/A"
										value={obj.cut}
										dropdownRender={(menu) => (
											<div>
												{menu}
												<Divider style={{ margin: "4px 0" }} />
												<div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
													<Input
														style={{ flex: "auto" }}
														value={cutName ? cutName : ""}
														onChange={onCutChange}
													/>
													{cutName ? (
														<a
															style={{
																flex: "none",
																padding: "8px",
																display: "block",
																cursor: "pointer"
															}}
															onClick={addCutOpt}
														>
															<PlusOutlined />
														</a>
													) : null}
												</div>
											</div>
										)}
									>

										{cutArr.length && cutArr.map((a, i) => (
											<Option value={a.value}>{a.value}</Option>
										))}
										<Option value="other">other</Option>
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div
								className="inputDiv"
								style={{ display: "flex", alignItems: "flex-end" }}
							>
								<div style={{ width: "calc(100% - 100px)" }}>
									<h6>Weights</h6>
									<Input
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.weight = e.target.value;
											setobj(obj2);
										}}
										value={obj.weight}
									/>
								</div>
								<Select
									style={{ width: 100 }}
									onChange={(e) => {
										let obj2 = { ...obj };
										obj2.weight_unit = e;
										setobj(obj2);
									}}
									className="select"
									defaultValue="CT"
									value={obj.weight_unit}
								>
									<Option value="CT">Carats</Option>
									<Option value="Gm">Grams</Option>
								</Select>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Clarity</h6>
									<Select
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.clarity = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue={DiamondCertificate.Clarity[0]}
										value={obj.clarity}
									>
										{DiamondCertificate.Clarity.map((val) => (
											<Option value={val}>{val}</Option>
										))}
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Color</h6>

									<Select
										showSearch
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.color = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue=""
										value={obj.color}
										dropdownRender={(menu) => (
											<div>
												{menu}
												<Divider style={{ margin: "4px 0" }} />
												<div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
													<Input
														style={{ flex: "auto" }}
														value={colorName ? colorName : ""}
														onChange={onColorChange}
													/>
													{colorName ? (
														<a
															style={{
																flex: "none",
																padding: "8px",
																display: "block",
																cursor: "pointer"
															}}
															onClick={addColorOpt}
														>
															<PlusOutlined />
														</a>
													) : null}
												</div>
											</div>
										)}
									>
										{colorArr.map((a, i) => {
											return <Option value={a.name}>{a.name}</Option>;
										})}
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>DiamondCut</h6>
									<Select
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.DiamondCut = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue={DiamondCertificate.Diamond_Cut[0]}
										value={obj.DiamondCut}
									>
										{DiamondCertificate.Diamond_Cut.map((val) => (
											<Option value={val}>{val}</Option>
										))}
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Polish</h6>
									<Select
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.polish = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue={DiamondCertificate.Polish[0]}
										value={obj.polish}
									>
										{DiamondCertificate.Polish.map((val) => (
											<Option value={val}>{val}</Option>
										))}
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Symmetry</h6>
									<Select
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.symmetry = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue={DiamondCertificate.Symmetry[0]}
										value={obj.symmetry}
									>
										{DiamondCertificate.Symmetry.map((val) => (
											<Option value={val}>{val}</Option>
										))}
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv">
								<div style={{ width: "39%", marginTop: 10 }}>
									<h6>Flourescence</h6>
									<Select
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.flourescence = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue=""
										value={obj.flourescence}
									>
										<Option value="None">None</Option>
										<Option value="Faint">Faint</Option>
										<Option value="Medium">Medium</Option>
										<Option value="Strong">Strong</Option>
										<Option value="Very Strong">Very Strong</Option>
									</Select>
								</div>

								<div style={{ width: "59%", marginTop: 10 }}>
									<h6>Colour</h6>
									<Select
										showSearch
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.flourescenceColor = e;
											setobj(obj2);
										}}
										className="select"
										defaultValue=""
										value={obj.flourescenceColor}
										dropdownRender={(menu) => (
											<div>
												{menu}
												<Divider style={{ margin: "4px 0" }} />
												<div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
													<Input
														style={{ flex: "auto" }}
														value={colorName ? colorName : ""}
														onChange={onColorChange}
													/>
													{colorName ? (
														<a
															style={{
																flex: "none",
																padding: "8px",
																display: "block",
																cursor: "pointer"
															}}
															onClick={addColorOpt}
														>
															<PlusOutlined />
														</a>
													) : null}
												</div>
											</div>
										)}
									>
										{colorArr.map((a, i) => {
											return <Option value={a.name}>{a.name}</Option>;
										})}
									</Select>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv commnetInput" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Comment</h6>
									<TextArea
										// value={value}
										// onChange={this.onChange}
										placeholder="Controlled autosize"
										autoSize={{ minRows: 3, maxRows: 5 }}
										onChange={(e) => {
											let obj2 = { ...obj };
											obj2.comment = e.target.value;
											setobj(obj2);
										}}
										value={obj.comment}
									/>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}>
							<div className="inputDiv" style={{ marginTop: 10 }}>
								<div style={{ width: "100%" }}>
									<h6>Product Image</h6>
									<div className="imageBox">
										<div
											className="box"
											style={{
												backgroundImage: `url('${image
													? image
													: obj.fpath
														? obj.fpath
														: obj.product_pic
															? obj.product_pic
															: upload
													}')`
											}}
										></div>
										<Input onChange={(e) => handleChange(e)} type="file" placeholder="upload" />
									</div>
								</div>
							</div>
						</Col>
						<Col xs={7} sm={7} md={7} lg={7} xl={7}></Col>
					</Row>
					{isEdit ? (
						<Button onClick={() => update()} type="primary" disabled={props.managerPanelLoading}>
							{props.managerPanelLoading ? <div className="loading1"></div> : "Update"}
						</Button>
					) : (
						<Button onClick={() => save()} type="primary" disabled={props.managerPanelLoading}>
							{props.managerPanelLoading ? <div className="loading1"></div> : "Save"}
						</Button>
					)}

					<Button
						onClick={() => props.history.goBack()}
						type="primary"
						style={{ margin: "0px 10px" }}
					>
						Cancel
					</Button>
				</div>
			) : (
				<h2>Already Delivered</h2>
			)}
		</div>
	);
}

const mapStateToProps = (store) => ({
	permission: store.users.permission,
	singleItemEntry: store.dataEntry.singleItemEntry,
	singleReportEntry: store.dataEntry.singleReportEntry,
	managerPanelLoading: store.managerPanel.managerPanelLoading,
	fields: store.FormValues

});

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setCertificate,
			getSingleItem,
			getSingleReport,
			updateCertificate,
			getSingleItemConsultation,
			getColorFormDataAdd,
			getCutFormDataAdd,
			getSpeciesFormDataAdd,
			getCuttingStyleFormDataAdd,
			getOrigionGemFormDataAdd,
			getGridlesFormDataAdd,
			getRemarksFormDatAdda,
			getVarietysFormDatAdda,
			getShapesFormDatAdda,
			getObjectsFormDataAdd
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(SmallDiamondForm);
